module.exports = __webpack_public_path__ + "img/1587028854.8ff5bc91.jpg";